import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { LikedGoodsCardItem } from '../utils/convertLikedGoodsItemToGoodsData';

export const useLogClickGoodsCtaButton = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (entry: LikedGoodsCardItem, eventName: string) => {
      logAnalyticsEvent({
        name: eventName,
        analytics: {
          ...entry.logging.analytics,
          LIST_ID: 'liked_list',
        },
        ably_only_log: entry.logging.ably_only_log,
      });
    },
    [logAnalyticsEvent],
  );
};
